import { Badge } from "@/components/ui/badge";
import { Form } from "@/components/Form";
import {
  MultiSelectCheckbox,
  MultiSelectOption,
} from "@/components/ui/multi-select-checkbox";

export type LinkedSeller = { id: number; name: string };

type SellersFieldProps = {
  sellers: { id: number | string; user?: { name?: string } }[];
  /** IDs (string) dos vendedores a adicionar. */
  value: string[];
  onChange: (values: string[]) => void;
  /** Vendedores já vinculados ao cliente (edição). */
  linked?: LinkedSeller[];
};

export const SellersField = ({
  sellers,
  value,
  onChange,
  linked = [],
}: SellersFieldProps) => {
  const linkedIds = linked.map((seller) => String(seller.id));
  const options: MultiSelectOption[] = sellers
    .filter((seller) => !linkedIds.includes(String(seller.id)))
    .map((seller) => ({
      value: String(seller.id),
      label: seller?.user?.name || String(seller.id),
    }));

  return (
    <Form.Item>
      <Form.Label>
        {linked.length > 0 ? "Vendedores vinculados" : "Vendedores"}
      </Form.Label>
      {linked.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {linked.map((seller) => (
            <Badge key={seller.id} variant="secondary" className="flex gap-1">
              {seller.name}
            </Badge>
          ))}
        </div>
      )}
      <MultiSelectCheckbox
        options={options}
        selectedValues={value}
        onSelectionChange={onChange}
        placeholder={
          linked.length > 0 ? "Adicionar vendedores" : "Selecione os vendedores"
        }
        selectAllLabel="SELECIONAR TODOS"
        searchable
        searchPlaceholder="Buscar vendedor..."
      />
    </Form.Item>
  );
};
